// extracted by mini-css-extract-plugin
export default {"container":"wsa-z","tab":"xsa-z","selected":"ysa-z"};